import React from "react";
import { Link } from "react-scroll";

export default function ContactButton() {
  return (
    <div className="flex text2 w-full justify-center  sm:justify-end mt-10">
      <Link
        to="contacts"
        smooth={true}
        duration={500}
        role="button"
        aria-label="Связаться с юристом"
        className="inline-block w-full sm:w-lg p-8 sm:rounded-full cursor-pointer content-center text-[#1F2732] text-center transition
          bg-[linear-gradient(0deg,rgba(255,255,255,0.2)_0%,rgba(255,255,255,0.2)_100%),linear-gradient(129deg,rgba(152,131,94,1)_24%,rgba(255,240,182,1)_52%,rgba(152,131,94,1)_100%)]"
      >
        Получить консультацию
      </Link>
    </div>
  );
}
